import React, { Component } from "react";

class CustomDivider extends Component {
  render() {
    return <hr className="avatar-divider" />
  }
}

export default CustomDivider;